module.exports = __webpack_public_path__ + "images/lynkco_smallf0429da5f95a72e2c7088ce853839053.png";